import * as types from './../constants/actionTypes';
import {PREPAID_CARD_URL} from './../constants/restURLs';
import {fetchApi} from './../api';
import {saveBalanceAccount} from './infoAccountActions';
import { push } from 'react-router-redux';
import {alertFailed, alertSuccess} from './AlertActions';

export const RefillPrepaidCard = (account, cardNumber, pincode) =>(dispatch) => {
    let lang = localStorage.getItem('lang');
    let params = `accountId=${account}&cardNumber=${cardNumber}&pincode=${pincode}&lgeCode=${lang}`;
    console.log('actions', params);
    let callbacks = {
        onSuccess: (response) => {
            console.log('response', response);
            dispatch(onSuccessfulRefillPrepaidCard());
            dispatch(saveBalanceAccount(response.newBalance));
            dispatch(push('/topUpEwallet'));

        },
        onFailed: (response, statusCode)=>{
            console.log('responseFaild', response);
            dispatch(onFailedRefillPrepaidCard());
            statusCode
            ? dispatch(alertFailed(statusCode))
            : dispatch(alertFailed(response.message));
        },
        onError:(error) => {
            console.log('responseError', error);
            dispatch(onFailedRefillPrepaidCard());
            dispatch(alertFailed(error));
        }
    }

    fetchApi(dispatch, PREPAID_CARD_URL, params, callbacks);
}

const onSuccessfulRefillPrepaidCard = () => {
    return{
        type: types.REFILL_PREPAID_CARD_SUCCESSFUL
    }
}

const onFailedRefillPrepaidCard = () => {
    return {
        type: types.REFILL_PREPAID_CARD_FAILED
    }
}



// WEBPACK FOOTER //
// ./src/actions/prepaidCardActions.js